import React, { PureComponent } from "react"
// import { Translate } from "react-localize-redux";
import {
    BinocVision,
    BothEyes,
    FarRightVision,
    FarLeftVision,
    SnellenVision,
    StereoDepthVision,
    ColorVision,
    LateralVision,
    NearBothEyes,
    NearRightVision,
    NearLeftVision,
    NearLateral,
} from "./"
import { VerticalVision } from "./VerticalVision";

export class VisionTable extends PureComponent {
    binocVision;
    bothEyes;
    farRightEyes;
    farLeftEyes;
    snellen;
    stereoDepthVision;
    colorVision;
    verticalVision;
    lateralVision;
    nearBothEyes;
    nearRightVision;
    nearLeftVision;
    nearLateral;
    parentSetState = (any) => {};
    constructor(props, setState) {
        super(props)
        this.binocVision = props.find(x => x.handle === 'binoc')
        this.bothEyes = props.find(x => x.handle === 'far_both')
        this.farRightEyes = props.find(x => x.handle === 'far_rt')
        this.farLeftEyes = props.find(x => x.handle === 'far_lt')
        this.snellen = props.find(x => x.handle === 'far_snellen')
        this.stereoDepthVision = props.find(x => x.handle === 'far_stereo')
        this.colorVision = props.find(x => x.handle === 'far_color')
        this.verticalVision = props.find(x => x.handle === 'far_vertical')
        this.lateralVision = props.find(x => x.handle === 'far_lateral')
        this.nearBothEyes = props.find(x => x.handle === 'near_both')
        this.nearRightVision = props.find(x => x.handle === 'near_rt')
        this.nearLeftVision = props.find(x => x.handle === 'near_lt')
        this.nearLateral = props.find(x => x.handle === 'near_lateral')
        this.parentSetState = setState;
    }
    render() {
        return (
            <div className="oc-form-group-wrapper oc-form-table-wrapper">
                <table className="oc-form-table">
                    <tbody>
                        <tr>
                            <td rowSpan="11" className="oc-form-table-aside-top">
                                <span>FAR POINT(20 FT.)TEATS</span>
                            </td>
                        </tr>
                        <BinocVision template={this.binocVision} setState={this.parentSetState.bind(this)}></BinocVision>
                        <tr className="oc-form-table-section-header">
                            <td colSpan="2">Target</td>
                            <td>1</td>
                            <td>2</td>
                            <td>3</td>
                            <td>4</td>
                            <td>5</td>
                            <td>6</td>
                            <td>7</td>
                            <td>8</td>
                            <td>9</td>
                            <td>10</td>
                            <td>11</td>
                            <td>12</td>
                            <td>13</td>
                            <td>14</td>
                            <td></td>
                        </tr>
                        <BothEyes template={this.bothEyes} setState={this.parentSetState.bind(this)}></BothEyes>
                        <FarRightVision template={this.farRightEyes} setState={this.parentSetState.bind(this)}></FarRightVision>
                        <FarLeftVision template={this.farLeftEyes} setState={this.parentSetState.bind(this)}></FarLeftVision>
                        <SnellenVision template={this.snellen} setState={this.parentSetState.bind(this)}></SnellenVision>
                        <StereoDepthVision template={this.stereoDepthVision} setState={this.parentSetState.bind(this)}></StereoDepthVision>
                        <ColorVision template={this.colorVision} setState={this.parentSetState.bind(this)}></ColorVision>
                        <VerticalVision template={this.verticalVision} setState={this.parentSetState.bind(this)}></VerticalVision>
                        <LateralVision template={this.lateralVision} setState={this.parentSetState.bind(this)}></LateralVision>
                        <tr>
                            <td rowSpan="6" className="oc-form-table-aside-bottom">
                                <span>NEAR POINT (14 IN.)</span>
                            </td>
                            <td colSpan="17" style={{padding: 0}}>
                                <hr />
                            </td>
                        </tr>
                        <tr className="oc-form-table-section-header">
                            <td colSpan="2">
                                Target
                            </td>
                            <td>1</td>
                            <td>2</td>
                            <td>3</td>
                            <td>4</td>
                            <td>5</td>
                            <td>6</td>
                            <td>7</td>
                            <td>8</td>
                            <td>9</td>
                            <td>10</td>
                            <td>11</td>
                            <td>12</td>
                            <td>13</td>
                            <td>14</td>
                            <td></td>
                        </tr>
                        <NearBothEyes template={this.nearBothEyes} setState={this.parentSetState.bind(this)}></NearBothEyes>
                        <NearRightVision template={this.nearRightVision} setState={this.parentSetState.bind(this)}></NearRightVision>
                        <NearLeftVision template={this.nearLeftVision} setState={this.parentSetState.bind(this)}></NearLeftVision>
                        <NearLateral template={this.nearLateral} setState={this.parentSetState.bind(this)}></NearLateral>
                    </tbody>
                </table>
            </div>
        )
    }
}